import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Imprint from '../views/Imprint.vue';
import HomeEn from '../views/Home_en.vue';
import ImprintEn from '../views/Imprint_en.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Home,
  },
  {
    // redirect everything else to home
    path: '*',
    redirect: '/',
    component: Home,
  },
  {
    path: '/en/home',
    component: HomeEn,
  },
  {
    path: '/imprint',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Imprint, // () => import(/* webpackChunkName: "imprint" */ '../views/Imprint.vue'),
  },
  {
    path: '/en/imprint',
    component: ImprintEn,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Remember scroll position on each page. So when going to another page jump to last known
    // scroll position or go to top of the page.
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

export default router;
